import React from "react";
 
class index extends React.Component {
	
	 
  	 
	
	render() {
		return (
		<>
			Formularios xFlow v2
			   </>
	        
	    );
    }
	}

export default index;
